import script from "./VNotificationBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./VNotificationBlock.vue?vue&type=script&setup=true&lang=js"

import "./VNotificationBlock.vue?vue&type=style&index=0&id=2d7b5017&lang=scss"

const __exports__ = script;

export default __exports__